import { DocumentData, DocumentReference } from "firebase/firestore";

export type UserModel = {
    id: string,
    email: string,
    displayName: string,
}

export type StudentModel = {
    _id: string,
    name: string,
    yearInCurriculum: string,
}

export type SubjectWorkOrderModel = {
    subject_name: string,
    work_order: string[]
}

export type WorkModel = {
    _id: string,
    id: number
    name: string,
    subject: string,
    progress: ProgressModel[],
};

export type ProgressModel = {
    student_id: string,
    student_name: string,
    status: Status,
    notes: string,
}

export interface Class {
    _id: string;
    name: string;
    nameAbbreviated: string;
    students: StudentModel[];
    works: WorkModel[];
}

export interface School {
    name: string;
    curriculumOrder: string[];
    curriculum: { [key: string]: DocumentReference<DocumentData, DocumentData>[] };
}

export enum Status {
    Unplanned = "Unplanned",
    Planned = "Planned",
    GaveALesson = "Gave a lesson",
    WorkingOnIt = "Working on it",
    Mastered = "Mastered"
}

export type UpdateStatusModel = {
    work_id: string, 
    student_id: string, 
    oldStatus: Status
}

export type UpdateNotesModel = {
    work_id: string, 
    student_id: string, 
    newNotes: string
}

export enum CurriculumYear {
    First = "1st",  
    Second = "2nd",
    Third = "3rd"
}

const subjects = [
    "Language",
    "Science",
    "Sensorial",
    "Math",
    "Practical Life",
    "Geography"
]

export type WorkSingleStudentModel = {
    work_id: string;
    id: number;
    name: string;
    subject: string;
    status: Status;
    notes: string;
};

/// Firestore types:

export type StudentData = {
    refPath: string,
    name: string,
    yearInCurriculum: string
}

export type ProgressData = {
    id: string,
    status: string,
    notes: string,
    subject: string,
    studentRefPath: string,
    workRefPath: string
}

export type WorkData = {
    name: string,
    subject: string
}

export type CurriculumAndWorks = {
    curriculum: { [key: string]: string[] };
    curriculumRefPaths: { [key: string]: string[] };
    curriculumOrder: string[];
    worksMap: { [key: string]: WorkData };
}

export type TeacherNameResponse = {
    name: string
}

export type CommentSectionData = {
    id: string,
    subject: string,
    studentRefPath: string,
    text: string
}